import { render, staticRenderFns } from "./MFormMinutes.vue?vue&type=template&id=2dedba26&"
import script from "./MFormMinutes.vue?vue&type=script&lang=js&"
export * from "./MFormMinutes.vue?vue&type=script&lang=js&"
import style0 from "./MFormMinutes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports